/**
 * Stable ids for planner sheet tabs, panels, and screen-reader summaries.
 *
 * @param {import("@plaatplan/core").LayoutSheet & { unused?: boolean, restStockId?: string, restStockOccurrence?: number }} sheet
 */
export function getSheetSurfaceId(sheet) {
  if (sheet.unused) {
    return `sheet-unused-${sheet.restStockId}-${sheet.restStockOccurrence}`;
  }

  return `sheet-${sheet.index}`;
}

/** @param {ReturnType<typeof getSheetSurfaceId> extends string ? Parameters<typeof getSheetSurfaceId>[0] : never} sheet */
export function getSheetTabId(sheet) {
  return `${getSheetSurfaceId(sheet)}-tab`;
}

/** @param {Parameters<typeof getSheetSurfaceId>[0]} sheet */
export function getSheetPanelId(sheet) {
  return `${getSheetSurfaceId(sheet)}-panel`;
}

/** @param {Parameters<typeof getSheetSurfaceId>[0]} sheet */
export function getSheetSummaryId(sheet) {
  return `${getSheetSurfaceId(sheet)}-summary`;
}
